module.exports = new __parcel__URL__("cornershop-shopper-ios.d4e943eb.webp").toString();